export default {
  colors: {
    black: '#000000',
    gray: '#414141',
    darkGray: '#1A1A1A',
    green: '#02d463',
    greenGlow: 'rgba(2, 212, 99, 0.35)',
    greenDim: 'rgba(2, 212, 99, 0.08)',
    greenBorder: 'rgba(2, 212, 99, 0.15)',
    white: '#ffffff',
    middleGray: '#2E2E2E',
    lightGray: '#b3b3b3',
    textMuted: '#d0d0d0',
  },
  breakPoints: {
    mobile: '765px',
    tablet: '985px',
    desktop: '1200px',
  },
} as const
